import { AxiosError, AxiosResponse, CancelToken } from "axios";
import { Action } from "redux";

import SearchActionTypes from "./action-types";
import {
    executeMainSearch,
    ISearchParams,
} from "./api";
import { SearchResponse, AiSearchSummary } from "./types";

export interface IClearSearchResultsAction extends Action {
    type: SearchActionTypes.ClearCurrentResults;
}

export type ClearResultsAction = () => IClearSearchResultsAction;
export const clearSearchResults: ClearResultsAction = () => ({
    type: SearchActionTypes.ClearCurrentResults,
});

export interface IExecuteSearchAction extends Action {
    payload: Promise<AxiosResponse<Spintr.ISearchResult[]>>;
    meta?: ISearchParams,
    type: SearchActionTypes.ExecuteSearch;
}

export interface IExecuteSearchFulfilledAction extends Spintr.IResolvedPromiseAction<
    AxiosResponse<SearchResponse>, ISearchParams | undefined
> {
    type: SearchActionTypes.ExecuteSearchFulfilled;
}

export interface IExecuteSearchPendingAction extends Action {
    type: SearchActionTypes.ExecuteSearchPending;
}

export interface IExecuteSearchRejectedAction extends Spintr.IAsyncActionError<
    AxiosError<any>, ISearchParams | undefined
> {
    type: SearchActionTypes.ExecuteSearchRejected;
}
 
export interface ISetOnedriveResultsAction extends Action {
    type: SearchActionTypes.SetOnedriveResults;
    results: any[];
}

export type SetOnedriveResultsAction = (results: any[]) => ISetOnedriveResultsAction;

export const setOnedriveResults: SetOnedriveResultsAction = (results: any[]) => ({
    type: SearchActionTypes.SetOnedriveResults,
    results
});

export interface ISetSharepointResultsAction extends Action {
    type: SearchActionTypes.SetSharepointResults;
    results: any[];
}

export type SetSharepointResultsAction = (results: any[]) => ISetSharepointResultsAction;

export const setSharepointResults: SetSharepointResultsAction = (results: any[]) => ({
    type: SearchActionTypes.SetSharepointResults,
    results
});

export type LoadCachedResultAction
    = Action<SearchActionTypes.LoadCachedResult>
    & { checksum: number };

export function loadCachedSearchResult(checksum: number): LoadCachedResultAction {
    return {
        type: SearchActionTypes.LoadCachedResult,
        checksum,
    };
}

export type ClearSearchCacheAction = Action<SearchActionTypes.ClearSearchCache>;
export function clearSearchCache(): ClearSearchCacheAction {
    return {
        type: SearchActionTypes.ClearSearchCache,
    };
}

export type SetSearchAiSummaryAction
    = Action<SearchActionTypes.SetAiSummary>
    & {
        summary: AiSearchSummary;
        checksum?: number;
    };

export function setSearchAiSummary(summary: AiSearchSummary, checksum?: number): SetSearchAiSummaryAction {
    return {
        type: SearchActionTypes.SetAiSummary,
        summary,
        checksum,
    };
}

export type SearchAction
    = IClearSearchResultsAction
    | IExecuteSearchAction
    | IExecuteSearchFulfilledAction
    | IExecuteSearchPendingAction
    | IExecuteSearchRejectedAction
    | ISetOnedriveResultsAction
    | ISetSharepointResultsAction
    | LoadCachedResultAction
    | ClearSearchCacheAction
    | SetSearchAiSummaryAction;
    ;

export type ExecuteSearchThunkPromise = 
    Spintr.ThunkPromise<
        AxiosResponse<SearchResponse> | AxiosError<any>, 
        IExecuteSearchFulfilledAction | IExecuteSearchRejectedAction
    >;
export type ExecuteSearchAction =
    (params: ISearchParams, cancelToken?: CancelToken) => IExecuteSearchAction | ExecuteSearchThunkPromise;

export const executeSearchAction: ExecuteSearchAction =
    (params, cancelToken) => ({
        meta: params, cancelToken,
        payload: executeMainSearch(params, cancelToken),
        type: SearchActionTypes.ExecuteSearch,
    });
